import React from "react"
import PropTypes from "prop-types"
import { ClockCircleOutlined, UserOutlined, TeamOutlined, TagOutlined, EnvironmentOutlined, FileDoneOutlined, FileExclamationOutlined } from "@ant-design/icons"
import { WAIVER_STATUS } from "pagesV2/pro/Calendar/shared/bookingTileUtils"
import styles from "./index.module.css"

const Row = ({ icon, value }) => {
  if (!value) return null
  return (
    <div className={styles.row}>
      <span className={styles.rowIcon} aria-hidden="true">
        {icon}
      </span>
      <span className={styles.rowValue}>{value}</span>
    </div>
  )
}

Row.propTypes = {
  icon: PropTypes.node,
  value: PropTypes.node
}

/**
 * Read-only content for the booking hover popover. Rows render only when their
 * value is present, so a missing resource / client simply drops out.
 */
const PopoverBody = ({ id, model, accentColor }) => (
  <div id={id} role="tooltip" className={styles.body}>
    {model.experienceName && (
      <div className={styles.header}>
        <span className={styles.title} style={{ color: accentColor }}>
          {model.experienceName}
        </span>
      </div>
    )}
    <div className={styles.rows}>
      <Row icon={<ClockCircleOutlined />} value={model.timeText} />
      <Row icon={<TagOutlined />} value={model.resourceName} />
      <Row icon={<UserOutlined />} value={model.clientName} />
      <Row icon={<TeamOutlined />} value={model.guestLabel} />
      <Row icon={<EnvironmentOutlined />} value={model.location} />
      <Row
        icon={model.waiverStatus === WAIVER_STATUS.SIGNED ? <FileDoneOutlined /> : <FileExclamationOutlined />}
        value={model.waiverLabel}
      />
    </div>
  </div>
)

PopoverBody.propTypes = {
  id: PropTypes.string,
  model: PropTypes.shape({
    title: PropTypes.string,
    experienceName: PropTypes.string,
    timeText: PropTypes.string,
    resourceName: PropTypes.string,
    clientName: PropTypes.string,
    guestLabel: PropTypes.string,
    location: PropTypes.string,
    waiverStatus: PropTypes.string,
    waiverLabel: PropTypes.string,
    accentColor: PropTypes.string
  }).isRequired
}

export default PopoverBody
